(function () {
  function initRive(canvas) {
    if (typeof rive === 'undefined') {
      console.error('Rive not loaded');
      return;
    }

    const RIV_BASE64 = canvas.dataset.base64;
    if (!RIV_BASE64) return;

    function base64ToBuffer(b64) {
      const binary = atob(b64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return bytes.buffer;
    }

    const stateMachine = canvas.dataset.stateMachine || 'State Machine 1';
    const triggerStage1 = canvas.dataset.triggerStage1 || 'Trigger_Stage1';
    const triggerStage2 = canvas.dataset.triggerStage2 || 'Trigger_Stage2';

    let riveInstance = new rive.Rive({
      buffer: base64ToBuffer(RIV_BASE64),
      canvas: canvas,
      stateMachines: stateMachine,
      autoplay: true,
      onLoad() {
        riveInstance.resizeDrawingSurfaceToCanvas();
        setupObserver(canvas, riveInstance);
      }
    });

    function getInput(name) {
      return riveInstance
        ?.stateMachineInputs(stateMachine)
        ?.find(i => i.name === name);
    }

    function setupObserver(canvas, instance) {
      let currentStage = 0;

      function checkPosition() {
        const rect = canvas.getBoundingClientRect();
        const vh = window.innerHeight;
        const centerPct = (rect.top + rect.height / 2) / vh;

        if (centerPct > 0.2 && centerPct < 0.8) {
          if (currentStage !== 2) {
            currentStage = 2;
            getInput(triggerStage2)?.fire();
          }
        } else if (currentStage === 2) {
          currentStage = 1;
          getInput(triggerStage1)?.fire();
        }
      }

      window.addEventListener('scroll', checkPosition, { passive: true });
        checkPosition();      
    }
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('.rive-canvas').forEach(initRive);
  });
})();